import { useContentAiGetStationConfig } from '@mi-front/api-v2';

/** Whether Content AI is enabled for a station (per-station config from the API). */
export function useIsContentAiForStationEnabled(stationId: string) {
  const config = useContentAiGetStationConfig(stationId);

  return config.data?.enabled ?? false;
}
